import React from 'react'
import "../CSS/login.css"
import "../CSS/global.css"


// react icons start 
import { IoIosArrowBack, IoIosArrowForward, IoMdAdd } from "react-icons/io";
import { IoLockClosedSharp, IoReload } from "react-icons/io5";
// react icons end

const Login = ({ children }) => {
  return (
    <div className=''>
      <div className='login_bg DFJCCAIC'>
        <div className='apple_design_container_outer '>
          <div className='apple_design_container_inner'>
            <div>
              <div className='apple_design_container_header DFJCBAIC'>
                <div className='DFJCCAIC gap50'>
                  <div className='apple_minimise_ryg'>
                    <span className=''> </span>
                    <span></span>
                    <span></span>
                  </div>

                  <div className='apple_arrow_front_back DFJCCAIC gap10'>
                    <span><IoIosArrowBack size={20} color='#d8d8d8' /></span>
                    <span><IoIosArrowForward size={20} color='#d8d8d8' /></span>
                  </div>

                </div>

                <div className='apple_search_header_container  '>
                  <div className='DFJCBAIC'>
                    <div></div>
                    <div className='DFJCCAIC gap5'>
                      <span><IoLockClosedSharp color='#7e7e7e' /></span>
                      <span>softTrack.com</span>
                    </div>
                    <div>
                      <span><IoReload color='#7e7e7e' /></span>
                    </div>

                  </div>
                </div>

                <div className='apple_arrow_front_back DFJCCAIC gap10'>
                  <span><IoMdAdd color='#d8d8d8' /></span>
                  {/* <span>Logout</span> */}
                </div>

              </div>
            </div>


            <hr />


          </div>
          <div className='chidren_container'>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login